/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-14 17:45:57
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-09-14 14:47:43
 * @FilePath: \baishu_react_ui\src\components\BsyBatchEditPane\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyWidget } from '../BsyWidget';
import BsySelect from '../BsySelect';
import BsyIconBtn from '../BsyIconBtn';
import './index.css'
import { BsyUtils } from '../../utils/Utils';
import tipAlert from '../../Login/BsyAlertTip/Staticize';
import BsyAlert from '../BsyAlert';
import BsySLoading from '../BsySLoading';
import BsyDialog from '../BsyDialog';
import BsyBatchEditpPeviewPane from '../BsyBatchEditpPeviewPane';
import { dayjsUtils } from '../../utils/dayjsUtils';

export default class BsyBatchEditPane extends BsyWidget {
  static defaultProps = {
    height: 470,
    perPage: 10,
    limit: 500,
    appId: null,
    entryId: null,
    formId: null,
    fields: [],
    idList: [],
    rel: "and",
    isUpdateAll: !1,
    onAfterUpdate: null,
    ignoreAuth: !0,
    showMode: '',
    resultList: [],
    filter: {},
    dynamicValue: '',
    valueMode: 'const',
    ValueTypeItems: [],
    widget: null,
    userdeptItems: [],
    formula: '',
    notAllowed: true,
    errorType: '' // noRepeat 字段属性重复 //notsupport 不支持的字段类型
  }
  constructor(props) {
    super(props);
    this.state = {
      ...props
    }

    this.widgets = {};

    let d = this.options
    let c = this;
    c.formulaFields = [];
    this.tdv = ['text', 'textarea', 'number', 'datetime', 'radiogroup', 'combo', 'sn', 'checkboxgroup', 'combocheck', 'location'];
    BsyUtils.forEach(d.fields, function (h, b) {


      if (d.authGroupId !== 0 && (d.ignoreAuth || (d.optAuth[b.widget.widgetName] && d.optAuth[b.widget.widgetName].visible))) {
        if (c.tdv.indexOf(b.widget.type) > -1) {
          c.formulaFields.push({
            name: b.widget.widgetName,
            title: b.label,
            type: b.widget.type,
          })
        }
      }

      if (d.authGroupId !== 0 && !d.ignoreAuth && d.optAuth) {
        if (d.optAuth[b.widget.widgetName]) {
          if (!d.optAuth[b.widget.widgetName].enable) {
            return;
          }
        }
      }



      switch (b.widget.type) {
        case "subform":

          BsyUtils.forEach(b.widget.items, function (t, n) {

            var subname = b.widget.widgetName + "." + n.widget.widgetName;


            if (d.authGroupId !== 0 && !d.ignoreAuth && d.optAuth) {
              if (d.optAuth[subname]) {
                if (!d.optAuth[subname].enable) {
                  return;
                }
              }
            }

            // if (!d.ignoreAuth) {
            //     if (d.optAuth[subname]) {
            //         if (!d.optAuth[subname].enable) {
            //             return;
            //         }
            //     }
            // }

            var s = { ...n };
            switch (s.widget.type) {
              case "address": {
                s.widget.width = 350;
                s.widget.width4province = 150;
                s.widget.width4city = 95;
                s.widget.width4district = 95;
                s.label = [b.label, n.label].join(".");
                s.widget.subform = b.widget.widgetName
                c.widgets[subname] = s
                break;
              }
              case "upload":
              case "linkquery":
              case "linkdata":
              case "location":
              case "image":
              case "signature":
              case "separator":
              case "dataload":
              case 'button':
                {
                  break;
                }
              default: {
                s.widget.width = 350;
                s.label = [b.label, n.label].join(".");
                s.widget.subform = b.widget.widgetName
                c.widgets[subname] = s
              }

            }
            // if (s.widget.type !== "address") {
            //     s.widget.width = 350;
            // }
            // else {
            //     s.widget.width = 350;
            //     s.widget.width4province = 150;
            //     s.widget.width4city = 95;
            //     s.widget.width4district = 95;
            // }

          });
          break;
        case "upload":
        case "linkquery":
        case "linkdata":
        case "location":
        case "image":
        case "signature":
        case "separator":
        case "dataload":
        case 'button':
          break;
        case "address":
          b.widget.width = 350;
          b.widget.width4province = 150;
          b.widget.width4city = 95;
          b.widget.width4district = 95;
          c.widgets[b.widget.widgetName] = b;
          break;
        default:
          b.widget.width = 350;
          c.widgets[b.widget.widgetName] = b;

      }
    })
    this.widgetlist = this._createSelectItems();

    if (d.authGroupId !== 0 && (d.ignoreAuth || (d.optAuth['creator'] && d.optAuth['creator'].visible))) {
      c.formulaFields.push({
        name: "creator",
        title: React.language('field.creator'),
        type: 'user',
      })
      this.widgets['creator'] = {
        label: React.language('field.creator'),
        widget: {
          type: 'user',
          widgetName: 'creator',
        },
      }

    }
    if (d.authGroupId !== 0 && (d.ignoreAuth || (d.optAuth['createTime'] && d.optAuth['createTime'].visible))) {
      c.formulaFields.push({
        name: "createTime",
        title: React.language('field.createTime'),
        type: 'datetime',
      })
      this.widgets['createTime'] = {
        label: React.language('field.createTime'),
        widget: {
          type: 'datetime',
          widgetName: 'createTime',
          format: 'yyyy-MM-dd HH:mm:ss'
        },
      }

    }
    if (d.authGroupId !== 0 && (d.ignoreAuth || (d.optAuth['updateTime'] && d.optAuth['updateTime'].visible))) {
      c.formulaFields.push({
        name: "updateTime",
        title: React.language('field.updateTime'),
        type: 'datetime',
      })
      this.widgets['updateTime'] = {
        label: React.language('field.updateTime'),
        widget: {
          type: 'datetime',
          widgetName: 'updateTime',
          format: 'yyyy-MM-dd HH:mm:ss'
        },
      }
    }

    if (d.authGroupId !== 0 && (d.ignoreAuth || (d.optAuth['_id'] && d.optAuth['_id'].visible))) {
      c.formulaFields.push({
        name: "_id",
        title: React.language('data.id'),
        type: 'text',
      })
      this.widgets['_id'] = {
        label: React.language('data.id'),
        widget: {
          type: 'text',
          widgetName: '_id',
        },
      }

    }


    this.wdigetRel = React.createRef();
    this.element = React.createRef();
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.state.showMode === 'showlog') {
      this.batchUpdataList();
    }
  }

  _createSelectItems = () => {
    var a = [];
    var ddb = ['']
    BsyUtils.forEach(this.widgets, function (b, c) {



      a.push({
        text: c.label,
        value: b,
      })
    })
    return a
  }

  getValueTypeItems = (value) => {
    const { authGroupId } = this.state;
    var d = this.widgets[value]

    if (!d.widget.subform && ['user', 'dept', 'usergroup', 'deptgroup'].indexOf(d.widget.type) > -1) {
      return [
        { value: "const", text: React.language('date.static') },
        { value: "dynamic", text: React.language('dash.guideline.dynamic') },
        { value: "formula", text: React.language('date.formula'), invalid: true },]
    }

    let vt = ['text', 'textarea', 'number', 'datetime', 'radiogroup', 'combo', 'textarea', 'sn', 'textarea'];
    if (vt.indexOf(d.widget.type) === -1) {
      return [
        { value: "const", text: React.language('date.static') },
        { value: "formula", text: React.language('date.formula'), invalid: true },]
    }

    //子表单字段，不支持公式编辑
    if (d.widget.subform) {
      return [
        { value: "const", text: React.language('date.static') },
        { value: "formula", text: React.language('date.formula'), invalid: true },]
    }
    return [
      { value: "const", text: React.language('date.static') },
      { value: "formula", text: React.language('date.formula'), invalid: authGroupId === 0 ? true : false },]

  }

  _setValWidget = (b) => {
    const { widget } = this.state;
    if (widget) {

      var c = { ...this.widgets[widget].widget };
      c.is_dock_form = this.props.is_dock_form;
      switch (c.type) {
        case "sn":
          c.type = 'text';
          c.value = null;
          c.text = null;
          break;
        case "text":

          if (["imageurl", "qrcode", "barcode"].indexOf(c.regex) > -1) {
            c.regex = '';
          }
          c.value = null;
          c.text = null;
          break;
        case "number":
        case "datetime":

          c.value = null;
          c.text = null;
          break;
        case "textarea":
          c.height = 130;
          c.value = null;
          c.text = null;
          break;
        case "address":
          c.value = {};
          c.seleceMapAddress = true;
          c.width = 450;
          break;
        case "radiogroup":
        case "combo":
          c.type = "combo";
          c.value = null;
          BsyUtils.forEach(c.items, function (a, b) {
            delete b.selected
          })
          break;
        case "checkboxgroup":
        case "combocheck":
          c.type = "combocheck";
          c.value = [];
          BsyUtils.forEach(c.items, function (a, b) {
            delete b.selected
          })
          break;
        case "user":
        case "dept":
          c.limit = {};
          c.limitWidget = null;
          c.value = []
          break;
        case "usergroup":
        case "deptgroup":
          c.limit = {};
          c.limitWidget = null;
          c.value = []
          break;
        default:
      }

      this.widget = window.FX.createWidget(window.$.extend({
        renderEl: window.$("<div/>").appendTo(window.$(this.wdigetRel.current).empty())
      }, c, {
        // authGroupId:this.options.authGroupId,
        appId: this.props.appId,
        entryId: this.props.entryId || this.props.formId,
        formId: this.props.formId || this.props.entryId,
        subform: widget.indexOf('.') > -1 ? widget.split('.')[0] : undefined,
        enable: !0,
        visible: !0,
        allowBlank: !0,
        autoHeight: !1,
        value: null,
        text: null,
      }))
    }
  }


  getWidgetValue = () => {
    if (this.widget.options.type == 'number') {
      return this.widget.getText();
    }
    return this.widget.getValue();
  }

  checkFormula = (cb) => {
    const { widget, filter, idList, isUpdateAll, valueMode, formula } = this.state;

    React.axios('/data/batch_update_check_formula', {
      authGroupId: this.props.authGroupId,
      appId: this.props.appId,
      entryId: this.props.entryId || this.props.formId,
      formId: this.props.formId || this.props.entryId,
      extDashData: this.props.extDashData,
      field: widget,
      filter: filter,
      jsplatform: "React",
      rel: "and",
      mode: valueMode,
      value: valueMode === 'formula' ? formula : this.getWidgetValue(),
      idList: idList,
      isUpdateAll: isUpdateAll,
    })
      .then((res) => {
        if (res.data.code !== 400) {
          cb && cb();
        }
      })
      .catch((res) => {
        console.error(res)
      })
  }

  onEditFormlua = () => {
    const { formula, widget } = this.state;
    let that = this;
    let e = { src: formula };
    var a = new window.FX.ConfirmDialog({
      title: React.language('formula.edit'),
      subTitle: React.language("formula.inputEnglish"),
      width: 800,
      height: 560,
      contentWidget: window.$.extend({}, e, {
        widgetName: "batchformulafieldeditpane",
        fields: this.formulaFields,
        supportFieldType: !0,
        limitFields: this.tdv,
        type: "batchformulafieldeditpane"
      }),
      onOk: function () {
        var e = this.container;
        if (e.checkValidate()) {
          var s = e.getField();


          if (that.widgets[widget].widget.type !== 'textarea') {
            // let d = s.src.split(/(\$[0-9a-zA-Z\._#@]+)/g)
            // console.log(d);
            if (s.src.indexOf('CHAR(10)') > -1) {
              tipAlert({
                type: "warning",
                msg: '非多行文本字段不允许有换行符'
              })
              //单行文本不允许有换行符
              return
            }
            if (s.src.indexOf('\\r') > -1) {
              //单行文本不允许有换行符
              tipAlert({
                type: "warning",
                msg: '非多行文本字段不允许有换行符'
              })
              return
            }
            if (s.src.indexOf('\\n') > -1) {
              //单行文本不允许有换行符
              tipAlert({
                type: "warning",
                msg: '非多行文本字段不允许有换行符'
              })
              return
            }

          }


          // BsyUtils.forEach(d, (a, d) => {
          //     if (BsyUtils.startWith(d, "$_widget_") || BsyUtils.startWith(d, "$_id") || BsyUtils.startWith(d, "$creator") || BsyUtils.startWith(d, "$updateTime") || BsyUtils.startWith(d, "$createTime")) {
          //         var f = d.replace("$", "").split("#")
          //             , g = f[0]
          //         console.log(f)
          //         if (that.widgets[g]) {
          //             ;
          //         } else {

          //         }
          //     } else {
          //         console.log(f)
          //     }
          // })

          that.setState({
            formula: s.src
          }, () => {
            that.checkFormula(() => {
              a.close();
            })
          })
        }
      }
    });
    a.show();

    let tydt = '文本型';
    switch (this.widgets[widget].widget.type) {
      case "number": {
        tydt = '数字型';
        break;
      }
      case "datetime": {
        tydt = '日期型';
        break;
      }
      default: {

      }
    }

    a.element.find('.formula-name').text(React.language('expr') + '（' + tydt + '）')
  }


  batchUpdata = () => {
    ///data/batch_update
    const { widget, filter, idList, isUpdateAll, valueMode, formula, dynamicValue } = this.state;
    this.element.current.classList.add('show-loading')
    React.axios('/data/batch_update', {
      authGroupId: this.props.authGroupId,
      appId: this.props.appId,
      entryId: this.props.entryId || this.props.formId,
      formId: this.props.formId || this.props.entryId,
      extDashData: this.props.extDashData,
      field: widget,
      filter: filter,
      jsplatform: "React",
      rel: "and",
      mode: valueMode,
      value: valueMode === 'formula' ? formula : valueMode === 'dynamic' ? dynamicValue : this.getWidgetValue(),
      idList: BsyUtils.isObjectEmpty(idList) ? undefined : idList,
      isUpdateAll: isUpdateAll,
    })
      .then((res) => {
        this.batchUpdataList();
        if (this.props.onAfterUpdate) {
          this.props.onAfterUpdate();
        }
      })
      .catch((res) => {
        console.error(res)
        this.batchUpdataList();
      })
  }

  batchUpdataList = () => {
    this.element.current.classList.add('show-loading')
    React.axios('/data/batch_update_tasks', {
      authGroupId: this.props.authGroupId,
      appId: this.props.appId,
      entryId: this.props.entryId || this.props.formId,
      formId: this.props.formId || this.props.entryId,
      extDashData: this.props.extDashData,
      limit: 1000,
      skip: 0
    })
      .then((res) => {
        this.element.current.classList.remove('show-loading')
        this.element.current.classList.add('show-result')
        console.log(res)
        this.setState({
          resultList: res.data.tasks,
        })
      })
      .catch((res) => {
        console.error(res)
        this.element.current.classList.remove('show-loading')
      })
  }


  getUserDeptItems = () => {
    const { widget } = this.state;
    let widgetType = this.widgets[widget].widget.type;
    let items = [];
    switch (widgetType) {
      case 'user': {
        items.push({
          value: '$creator#',
          text: React.language('field.creator'),
        })
        for (let i = 0; i < this.widgetlist.length; i++) {
          if (this.widgetlist[i].value.indexOf('.') > -1) {
            continue
          }
          if (this.widgetlist[i]) {
            if (this.widgets[this.widgetlist[i].value]) {

              console.log(this.widgets[this.widgetlist[i].value])

              if (this.widgets[this.widgetlist[i].value].widget.type === widgetType) {
                items.push({
                  ...this.widgetlist[i],
                  value: '$' + this.widgetlist[i].value + '#'
                })
              }
            }
          }
        }
        break
      }
      case 'dept': {
        // items.push({
        //     value: 'creatorInDept',
        //     text: '提交人所在的部门',
        // })
        for (let i = 0; i < this.widgetlist.length; i++) {
          if (this.widgetlist[i].value.indexOf('.') > -1) {
            continue
          }
          if (this.widgetlist[i]) {
            if (this.widgets[this.widgetlist[i].value]) {

              console.log(this.widgets[this.widgetlist[i].value])

              if (this.widgets[this.widgetlist[i].value].widget.type === widgetType) {
                items.push({
                  ...this.widgetlist[i],
                  value: '$' + this.widgetlist[i].value + '#'
                })
              }
            }
          }
        }
        break
      }
      case 'usergroup':
      case 'deptgroup': {
        for (let i = 0; i < this.widgetlist.length; i++) {
          if (this.widgetlist[i].value.indexOf('.') > -1) {
            continue
          }
          if (this.widgetlist[i]) {
            if (this.widgets[this.widgetlist[i].value]) {

              console.log(this.widgets[this.widgetlist[i].value])

              if (this.widgets[this.widgetlist[i].value].widget.type === widgetType) {
                items.push({
                  ...this.widgetlist[i],
                  value: '$' + this.widgetlist[i].value + '#'
                })
              }
            }
          }
          // if (this.widgets[this.widgetlist[i].value] && this.widgets[this.widgetlist[i].value].widget.type === widgetType) {
          //     items.push({
          //         ...this.widgetlist[i]
          //     })
          // }
        }
        break
      }
      default: {
        items = [];
      }
    }
    return items;
  }


  batchDataPeview = () => {
    let that = this;
    const { widget, filter, idList, isUpdateAll, valueMode, formula, dynamicValue, is_dock_form } = this.state;

    let postData = {
      authGroupId: this.props.authGroupId,
      appId: this.props.appId,
      entryId: this.props.entryId || this.props.formId,
      formId: this.props.formId || this.props.entryId,
      is_dock_form: is_dock_form,
      field: widget,
      filter: filter,
      jsplatform: "React",
      rel: "and",
      mode: valueMode,
      value: valueMode === 'formula' ? formula : valueMode === 'dynamic' ? dynamicValue : this.getWidgetValue(),
      idList: idList,
      isUpdateAll: isUpdateAll,
    }
    let fields = [
      {
        type: this.widgets[widget].widget.type,
        name: 'modifyfield',
        text: this.widgets[widget].label,
        format: this.widgets[widget].widget.format,
        regex: this.widgets[widget].widget.regex,
        afterSuffix: this.widgets[widget].widget.afterSuffix,
      },
      {
        type: this.widgets[widget].widget.type,
        name: this.widgets[widget].widget.widgetName,
        text: this.widgets[widget].label,
        format: this.widgets[widget].widget.format,
        regex: this.widgets[widget].widget.regex,
        afterSuffix: this.widgets[widget].widget.afterSuffix,
      }
    ]

    if (widget.indexOf('.') > -1) {
      fields = [
        {
          name: this.widgets[widget].widget.subform,
          type: 'subform',
          text: this.widgets[widget].label.split('.')[0],
          items: [{
            type: this.widgets[widget].widget.type,
            name: 'modifyfield',
            text: this.widgets[widget].label.split('.')[1],
            format: this.widgets[widget].widget.format,
            regex: this.widgets[widget].widget.regex,
            afterSuffix: this.widgets[widget].widget.afterSuffix,
          }, {
            type: this.widgets[widget].widget.type,
            name: widget.split('.')[1],
            text: this.widgets[widget].label.split('.')[1],
            format: this.widgets[widget].widget.format,
            regex: this.widgets[widget].widget.regex,
            afterSuffix: this.widgets[widget].widget.afterSuffix,
          }]
        },
      ]
    }


    if (BsyUtils.isString(postData.value)) {
      let dv = postData.value + '';
      if (dv.indexOf("$_widget_") > -1 || dv.indexOf("$_id") > -1 ||
        dv.indexOf("$creator") > -1 || dv.indexOf("$updateTime") > -1 ||
        dv.indexOf("$createTime") > -1) {

        let d = dv.split(/(\$[0-9a-zA-Z\._#@]+)/g)
        BsyUtils.forEach(d, (a, d) => {
          if (BsyUtils.startWith(d, "$_widget_") || BsyUtils.startWith(d, "$_id") || BsyUtils.startWith(d, "$creator") || BsyUtils.startWith(d, "$updateTime") || BsyUtils.startWith(d, "$createTime")) {
            var f = d.replace("$", "").split("#")
              , g = f[0]
            if (that.widgets[g]) {
              fields.push({
                type: that.widgets[g].widget.type,
                name: that.widgets[g].widget.widgetName,
                text: that.widgets[g].label,
                format: that.widgets[g].widget.format,
                regex: that.widgets[g].widget.regex,
              })
            }
          }
        })
      }
    }

    fields.push({
      type: 'user',
      name: 'creator',
      text: React.language('field.creator'),
    })
    fields.push({
      type: 'datetime',
      name: 'createTime',
      format: 'yyyy-MM-dd HH:mm:ss',
      text: React.language('field.createTime'),
    })
    fields.push({
      type: 'datetime',
      name: 'updateTime',
      format: 'yyyy-MM-dd HH:mm:ss',
      text: React.language('field.updateTime'),
    })
    fields.push({
      type: 'text',
      name: '_id',
      text: React.language(React.language('data.id')),
    })

    BsyDialog({
      title: React.language('data.batch.edit.peview'),
      subTitle: React.language('data.batch.edit.peview.subtitle'),
      customCls: "data-batch-edit-peview",
      height: 600,
      width: document.body.clientWidth - 280,
      noFooter: true,
      onContentCreate: (e) => {
        return <BsyBatchEditpPeviewPane
          postData={postData}
          fields={fields}
          newValue={this.formatValue(this.widgets[widget], postData.value)}
          fieldName={this.widgets[widget] ? this.widgets[widget].label : widget}
          extDashData={this.props.extDashData}
          onOk={() => {
            e.closeAlter()
            this.batchUpdata()
          }}
          onCancel={() => {
            e.closeAlter()
          }}
        />
      }
    })
  }

  formatValue = (e, value) => {
    let that = this;
    let f = '';
    if (e) {

      let dv = value + '';
      if (BsyUtils.isString(value) && (dv.indexOf("$_widget_") > -1 || dv.indexOf("$_id") > -1 ||
        dv.indexOf("$creator") > -1 || dv.indexOf("$updateTime") > -1 ||
        dv.indexOf("$createTime") > -1)) {

        let html = [];
        let d = dv.split(/(\$[0-9a-zA-Z\._#@]+)/g)
        BsyUtils.forEach(d, (a, d) => {
          if (BsyUtils.startWith(d, "$_widget_") || BsyUtils.startWith(d, "$_id") || BsyUtils.startWith(d, "$creator") || BsyUtils.startWith(d, "$updateTime") || BsyUtils.startWith(d, "$createTime")) {
            var f = d.replace("$", "").split("#")
              , g = f[0]
            if (that.widgets[g]) {
              html.push('<span class="field">' + that.widgets[g].label + '</span>')
            } else {
              html.push(d)
            }
          } else {
            html.push(d)
          }
        })

        f = html.join('');
      } else {
        switch (e.widget.type) {
          case "datetime":

            if (new Date(value) === 'Invalid Date') {
              f = '';
            } else {
              if (value)
                f = BsyUtils.date2Str(dayjsUtils.timeToTZ(value), e.widget.format);
            }

            break;
          case "number":
            if (BsyUtils.isNumber(value)) {
              f = BsyUtils.num2Str(value, e.widget.format);
            } else {
              f = value
            }
            break;
          case "address":
            f = BsyUtils.address2Str(value, "pcda", '-');
            if (f === "pcda") {
              f = value
            }
            break;
          case "dept":
          case 'user': {
            if (this.widget && this.widget.selectMap && this.widget.selectMap[value]) {
              f = this.widget.selectMap[value].name;
            } else {
              f = value;
            }
            break;
          }
          case "deptgroup":
          case 'usergroup': {

            let dd = [];
            for (let i = 0; i < value.length; i++) {
              if (this.widget && this.widget.selectMap && this.widget.selectMap[value[i]]) {
                dd.push(this.widget.selectMap[value[i]].name)
              } else {
                dd.push(value[i])
              }
            }
            f = dd.join("、");
            break;
          }
          default:
            f = BsyUtils.isArray(value) ? value.join("、") : value
            break;
        }
      }

      if (f && f.indexOf('NaN') > -1) {
        f = value
      }

    } else {
      f = value;
    }
    return f;
  }

  render() {
    const { notAllowed, ValueTypeItems, valueMode, widget, userdeptItems, formula, errorType, resultList, dynamicValue } = this.state;

    return (
      <div className={"bsy-batch-edit-pane " + (this.state.showMode === 'showlog' ? "show-result" : '')} ref={this.element}>
        <div className='content-main'>
          <div className="edit-info-item">
            <p>{React.language('data.batch.edit.tip')}</p>
            <p>{React.language('data.batch.edit.tip.distinct')}</p>
            <p>{React.language('data.batch.edit.tip.field')}</p>
          </div>

          <div className="edit-label">{React.language('data.batch.edit.field.select')}</div>
          <div className="widget-wrapper">
            <BsySelect
              allowBlank={false}
              items={this.widgetlist}
              value={widget}
              onStopEdit={(val) => {

                if (this.widgets[val]) {
                  if (this.widgets[val].widget.noRepeat || this.widgets[val].widget.noSingleDataRepeat) {
                    this.setState({
                      notAllowed: true,
                      widget: val,
                      formula: '',
                      errorType: React.language("data.batch.edit.warning.distinct") //'noRepeat'
                    })
                  } else {
                    let ValueTypeItems = this.getValueTypeItems(val)
                    this.setState({
                      valueMode: 'const',
                      dynamicValue: '',
                      widget: val,
                      errorType: '',
                      notAllowed: false,
                      ValueTypeItems,
                      formula: '',
                    }, () => {
                      this._setValWidget();
                    })
                  }

                } else {
                  this.setState({
                    notAllowed: true,
                    widget: val,
                    formula: '',
                    errorType: React.language("data.batch.edit.warning.field") //'notsupport 
                  })
                }
              }}
            >
            </BsySelect>
          </div>
          <div className="widget-error-info"
            style={{ display: errorType ? 'block' : "none" }}
          >{errorType}</div>
          <div className="edit-label">
            <span>{React.language('field.update')}</span>
            <div
              style={{ display: errorType ? 'none' : !widget ? 'none' : "block" }}
            >
              <BsySelect
                key={'kdeyd' + new Date().getTime()}
                allowBlank={false}
                searchable={false}
                value={valueMode}
                width={150}
                items={ValueTypeItems}
                onStopEdit={(val) => {
                  let duserdeptItems = [];
                  if (val === "dynamic") {
                    duserdeptItems = this.getUserDeptItems();
                  }
                  this.setState({
                    valueMode: val,
                    userdeptItems: duserdeptItems,
                    dynamicValue: '',
                  }, () => {
                    if (val === "dynamic") {
                      window.$(this.wdigetRel.current).empty()
                    } else {
                      this._setValWidget();
                    }
                  })

                }}
              >
              </BsySelect>
            </div>


          </div>
          <div className="widget-wrapper">
            <div className="not-allowed"
              style={{ display: notAllowed ? 'block' : "none" }}
            ></div>

            <div className="widget-content" ref={this.wdigetRel}
              style={{ display: notAllowed ? 'none' : !widget ? 'none' : (valueMode === 'const') ? "flex" : 'none' }}
            >

            </div>
            <div className="widget-content"
              style={{ display: valueMode === 'dynamic' ? "flex" : 'none' }}
            >
              <BsySelect
                key={'kegyd' + new Date().getTime()}
                allowBlank={false}
                searchable={false}
                value={dynamicValue}
                width={350}
                items={userdeptItems}
                onStopEdit={(val) => {
                  this.setState({
                    dynamicValue: val,
                  })
                }}
              >
              </BsySelect>
              {/* <div style={{ display: (dynamicValue === 'creatorInDept' ? 'flex' : 'none') }}>
                                <span style={{ width: 80, textAlign: 'center' }} > 可选范围</span>
                                <BsyDeptGroup
                                    width={200}
                                ></BsyDeptGroup>
                            </div> */}

            </div>
            <div
              style={{ display: notAllowed ? 'none' : !widget ? 'none' : (valueMode === 'const' || valueMode === 'dynamic') ? "none" : 'block' }}
            >
              <BsyIconBtn
                key={'button' + new Date().getTime()}
                mode={window.mode}
                type={'widget-formula'}
                iconName={'icon-function'}
                text={formula ? React.language('field.formula.edit.done') : React.language('field.formula.edit')}
                click={(e) => {
                  this.onEditFormlua()
                }}
              />
            </div>


          </div>
          <div className="edit-footer">
            <div className="edit-btn-left" onClick={this.batchUpdataList}>{React.language('data.batch.edit.record.view')}</div>

            <BsyIconBtn
              mode={window.mode}
              type={'edit-btn'}
              text={React.language('cancel')}
              click={(e) => {
                if (this.props.onCancel) {
                  this.props.onCancel();
                }
              }}
            />
            <BsyIconBtn
              mode={window.mode}
              text={React.language('data.batch.edit.peview.btn')}
              type={"blue edit-btn"}
              click={(e) => {


                if (this.state.errorType) {
                  tipAlert({
                    type: "warning",
                    msg: React.language('data.batch.edit.field.select')
                  })
                  return;
                }

                if (this.state.widget) {

                  if (
                    (this.state.valueMode === 'dynamic' && BsyUtils.isObjectEmpty(this.state.dynamicValue)) ||
                    (this.state.valueMode === 'formula' && BsyUtils.isObjectEmpty(this.state.formula)) ||
                    (this.state.valueMode === 'const' && BsyUtils.isObjectEmpty(this.getWidgetValue()))
                  ) {

                    BsyAlert({
                      title: React.language("data.batch.edit"),
                      msg: React.language("edit.field.empty.tip"),
                      type: "warning",
                      OkType: 'blue',
                      text4Ok: React.language("ok"),
                      text4Cancel: React.language("cancel"),
                      ok: () => {
                        // this.batchUpdata();
                        this.batchDataPeview();
                      }
                    })
                  } else {
                    // this.batchUpdata();
                    this.batchDataPeview();
                  }

                } else {
                  tipAlert({
                    type: "warning",
                    msg: React.language('data.batch.edit.field.select')
                  })
                }


                if (this.props.onOk) {
                  this.props.onOk();
                }
              }}
            />
          </div>
        </div>
        <div className='content-result'>
          <div className="title-bar">
            {
              !this.state.showMode && <i className="x-icon icon-bsy-left" onClick={() => {
                this.element.current.classList.remove('show-loading')
                this.element.current.classList.remove('show-result')
              }} ></i>
            }


            {React.language('update.record')}</div>
          {
            resultList.length === 0 ? <div className='empty-tip'>{React.language('update.record.none')}</div>
              :
              <div className='record-wrapper'>
                {
                  resultList.map((b, index) => {
                    if (!b.task || !b.task.field) {
                      return '';
                    }
                    let e = this.widgets[b.task.field]
                    if (!e) {
                      return '';
                    }

                    let f = this.formatValue(e, b.task.value);
                    return <div className="edit-list-item"
                      key={"edit-list-item" + index}
                    >
                      <div className="line-info">{React.language('update.time.label') + BsyUtils.date2Str(dayjsUtils.timeToTZ(b.startTime), "yyyy-MM-dd HH:mm:ss")}      </div>
                      <div className="line-info">{React.language("edit.user") + (b.operator ? BsyUtils._toDeptUser(b.operator) : '')}</div>
                      <div className="line-info">{React.language('update.field.label')}
                        <span className={!e ? "field-invalid" : ''}>
                          {!e ? React.language('field.deleted.tip') : e.label}
                        </span>
                      </div>
                      <div className="line-info">{React.language('newValue.label')}<span dangerouslySetInnerHTML={{ __html: f }} ></span></div>
                      <div className="line-info">
                        <div className="col-4">{React.language("update.dataCount", { count: b.count.total })}</div>
                        <div className="col-4">{React.language("update.dataCount.success", { count: b.count.success })}</div>
                        <div className="col-4">{React.language("update.dataCount.fail", { count: b.count.fail })}</div>
                      </div>
                    </div>
                  })
                }
              </div>
          }
        </div>
        <BsySLoading></BsySLoading>
      </div>
    );
  }
}
